export const ListQueryKey = 'activityZkRecords';
export const DetailQueryKey = 'activityRecommendRecord';
export const Urls = {
  selectUrl: '/ZkRecord/list',
  updateUrl: '/ZkRecord/update',
  deleteUrl: '/ZkRecord/delete',
  createUrl: '/ZkRecord/create',
  detailUrl: '/ZkRecord/info'
};